import { render, staticRenderFns } from "./activitiesDetail2023jy.vue?vue&type=template&id=749edf3e&scoped=true"
import script from "./activitiesDetail2023jy.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023jy.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023jy.vue?vue&type=style&index=0&id=749edf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749edf3e",
  null
  
)

export default component.exports